import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import AccordionHeaderContent from './AccordionHeaderContent'
import NotStartedStepMessage from './NotStartedStepMessage'
import { getStepState } from '../utils/getStepState'

interface AccordionShippedProps {
  stepProgress: number
}

const AccordionShipped: React.FC<AccordionShippedProps> = ({ stepProgress }) => {
  const stepState = getStepState(stepProgress)

  return (
    <Accordion.Item eventKey="9" className={`${stepState}-state desabled`}>
      <Accordion.Header>
        <AccordionHeaderContent
          stepState={stepState}
          progress={stepProgress}
          title="Enviado para Clínica"
        />
      </Accordion.Header>

      <Accordion.Body>
        <div className="check-sample p-3">
          {stepProgress < 9 ? (
            <NotStartedStepMessage />
          ) : (
            <>
              <p className="mb-0">Sua amostra de sêmen foi enviada para a clínica!</p>

              <p className="mb-0 mt-3">Por favor confirme o recebimento diretamente com a equipe clínica.</p>

              <p className="mb-0 mt-3">Muito obrigado por ter escolhido o Pro-Seed para fazer parte do seu sonho!</p>

              <p className="mb-0 mt-3">Ficamos honrados com a sua escolha!</p>

              <p className="mb-0 mt-3">Desejamos muito sucesso no seu tratamento e aguardamos as boas notícias!</p>
            </>
          )}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  )
}

export default AccordionShipped
